/**
 * LotoWheel Modal — Tab Fichas (chips del casino)
 * Se extiende sobre LotowheelModule declarado en lotowheel.js
 */

import { LotowheelModule, CHIP_COLORS, CHIP_CREDIT_VALUES } from './lotowheel.js';
import { icon } from '../../../utils/icon.js';
import { t } from '../../../services/i18n-admin.js';

Object.assign(LotowheelModule, {
    // ====================================================================
    // TAB FICHAS — Chips del casino
    // ====================================================================

    // Genera label legible desde creditos: 5 -> "5", 1000 -> "1K"
    generateChipLabel(creditos) {
        if (creditos >= 1000) {
            const k = creditos / 1000;
            return Number.isInteger(k) ? k + 'K' : creditos.toString();
        }
        return creditos.toString();
    },

    renderChipsList() {
        const list = document.getElementById('chipsList');
        const header =
            '<div class="chips-header">' +
            '<span>' + t('Vista') + '</span>' +
            '<span>' + t('Creditos') + '</span>' +
            '<span>Color</span>' +
            '<span></span>' +
            '</div>';
        const rows = this.currentChips
            .map((chip, i) => {
                return `
      <div class="chip-row">
        <div class="chip-preview" style="background:${chip.color}">${chip.label}</div>
        <input type="number" class="form-input chip-value" value="${chip.valor}" step="1" min="1" data-action="lotowheel:updateChipValue" data-index="${i}" placeholder="5">
        <input type="color" class="color-input" value="${chip.color}" data-action="lotowheel:updateChipColor" data-index="${i}">
        <button class="btn-icon" data-action="lotowheel:removeChip" data-index="${i}">${icon('trash-2')}</button>
      </div>
    `;
            })
            .join('');
        list.innerHTML = header + rows;
        // Iconos locales
        this.validatePremioMaximo();
    },

    /**
     * Valida que el premioMaximo sea representable con las fichas configuradas.
     * Apuesta maxima en pleno = premioMaximo / 36
     * Maximo representable = fichaMax * denominacion * 5 (variantes) * 4 (grupos)
     */
    validatePremioMaximo() {
        const hintEl = document.getElementById('hintPremioMax');
        if (!hintEl) return;

        const premioMaximo = parseInt(document.getElementById('lotowheelConfigPremioMax')?.value) || 360000;
        const denominacion = parseInt(document.getElementById('lotowheelConfigDenominacion')?.value) || 10;

        // Apuesta maxima implicita en pleno (derivada del premio maximo)
        const apuestaMaximaPleno = Math.floor(premioMaximo / 36);

        // Obtener ficha maxima (en creditos)
        const fichaMaxCreditos = this.currentChips.length > 0 ? Math.max(...this.currentChips.map(c => c.valor)) : 50;

        // Maximo representable en centavos: fichaMax * denominacion * 5 variantes * 4 grupos
        const maxRepresentable = fichaMaxCreditos * denominacion * 5 * 4;

        if (apuestaMaximaPleno > maxRepresentable) {
            hintEl.textContent = `[!] Apuesta max pleno (${apuestaMaximaPleno}) excede lo representable (${maxRepresentable} = ${fichaMaxCreditos}cr × ${denominacion} × 5 × 4)`;
            hintEl.style.color = '#ff9800';
        } else {
            hintEl.textContent = `✓ Apuesta max pleno: ${apuestaMaximaPleno}. Representable: ${maxRepresentable}`;
            hintEl.style.color = '#4caf50';
        }
    },

    updateChipValue(index, creditos) {
        const val = parseInt(creditos);
        if (isNaN(val) || val <= 0) return;
        this.currentChips[index].valor = val;
        this.currentChips[index].label = this.generateChipLabel(val);
        this.renderChipsList();
    },

    updateChip(index, field, value) {
        this.currentChips[index][field] = value;
        this.renderChipsList();
    },

    getNextChipColor() {
        const usedColors = this.currentChips.map(c => c.color.toLowerCase());
        for (const color of CHIP_COLORS) {
            if (!usedColors.includes(color.toLowerCase())) {
                return color;
            }
        }
        return CHIP_COLORS[Math.floor(Math.random() * CHIP_COLORS.length)];
    },

    getNextChipCredits() {
        if (this.currentChips.length === 0) return CHIP_CREDIT_VALUES[0];
        const usados = this.currentChips.map(c => c.valor);
        // Buscar el primer valor de la progresion que no este usado
        for (const val of CHIP_CREDIT_VALUES) {
            if (!usados.includes(val)) return val;
        }
        // Si todos usados, calcular siguiente
        const ultimo = Math.max(...usados);
        return ultimo * 2;
    },

    addChip() {
        const creditos = this.getNextChipCredits();
        const label = this.generateChipLabel(creditos);
        const color = this.getNextChipColor();
        this.currentChips.push({ valor: creditos, label, color });
        this.renderChipsList();
    },

    removeChip(index) {
        this.currentChips.splice(index, 1);
        this.renderChipsList();
    },
});
